module.exports = "https://r.zoocdn.com/_next/static/images/favicon-16x16-239658ffb005d4c676f5cb072893cc1a.png";